/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StreakChallengeListEntry } from './StreakChallengeListEntry';
import {
    StreakChallengeListEntryFromJSON,
    StreakChallengeListEntryFromJSONTyped,
    StreakChallengeListEntryToJSON,
    StreakChallengeListEntryToJSONTyped,
} from './StreakChallengeListEntry';

/**
 * 
 * @export
 * @interface StreakChallengeListResponse
 */
export interface StreakChallengeListResponse {
    /**
     * 
     * @type {Array<StreakChallengeListEntry>}
     * @memberof StreakChallengeListResponse
     */
    challenges: Array<StreakChallengeListEntry>;
}

/**
 * Check if a given object implements the StreakChallengeListResponse interface.
 */
export function instanceOfStreakChallengeListResponse(value: object): value is StreakChallengeListResponse {
    if (!('challenges' in value) || value['challenges'] === undefined) return false;
    return true;
}

export function StreakChallengeListResponseFromJSON(json: any): StreakChallengeListResponse {
    return StreakChallengeListResponseFromJSONTyped(json, false);
}

export function StreakChallengeListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakChallengeListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'challenges': ((json['challenges'] as Array<any>).map(StreakChallengeListEntryFromJSON)),
    };
}

export function StreakChallengeListResponseToJSON(json: any): StreakChallengeListResponse {
    return StreakChallengeListResponseToJSONTyped(json, false);
}

export function StreakChallengeListResponseToJSONTyped(value?: StreakChallengeListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenges': ((value['challenges'] as Array<any>).map(StreakChallengeListEntryToJSON)),
    };
}

